import { firebase } from './api/firebase'
import { firebaseAction } from 'vuexfire'
const db = firebase.database()
const environment = require('@/environments/production')

export default {
  namespaced: true,
  state: {
    kind: 'inventory',
    paginationPage: 1,
    itemsPerPage: 18,
    allItems: []
  },
  getters: {
    paginationCountLimit: (state, getters, rootState) => {
      return (rootState.layout.layoutBinding.column) ? 8 : state.itemsPerPage
    },
    getAllItemCount: state => {
      return state.allItems.length
    },
    getFilteredItemCount: (state, getters) => {
      return getters.getFilteredItems.length
    },
    getTotalPages: (state, getters) => {
      return Math.ceil(getters.getFilteredItemCount / getters.paginationCountLimit)
    },
    getItemsToDisplay: (state, getters) => {
      let startAt = (state.paginationPage - 1) * getters.paginationCountLimit
      let endAt = state.paginationPage * getters.paginationCountLimit
      return getters.getFilteredItems.slice(startAt, endAt)
    },
    getFilteredItems: (state, getters, rootState) => {
      // we want to build a filtering pipeline
      // we need to filter state.allItems to state.allFilteredItems
      // based off of what filters are currently in place.
      //
      // solution below lifted from one of the answers on the below link.
      // https://stackoverflow.com/questions/44330952/filter-array-of-objects-by-multiple-properties-and-values
      let filterOpts = [
        ['groupId', 'selectedGroupId'],
        ['collection', 'selectedCollection'],
        ['colorGroups', 'selectedColorGroups', 'contains'],
        ['fabric', 'selectedFabric'],
        ['style', 'selectedStyle'],
        ['size', 'selectedSize']
      ]

      let filters = {}
      filterOpts.forEach(filter => {
        if (rootState.itemFilters[filter[1]]) {
          filters[filter[0]] = rootState.itemFilters[filter[1]]
        }
      })
      if (Object.keys(filters).length < 1) {
        // since there are no filters...return everything...
        // unless we're looking at marketplace items ;p
        let filteredItems = state.allItems.slice()
        if (state.kind === 'marketplace') {
          let now = new Date().getTime()
          console.log('filtering marketplace for embargoTime')
          filteredItems = filteredItems.filter(i => {
            console.log(`testing: ${i.embargoTime} < ${now}`)
            return i.embargoTime < now
          })
        }
        return filteredItems.reverse()
      }
      let filtered = (targetArray, filters) => {
        let filterKeys = Object.keys(filters)
        return targetArray.filter(function (eachObj) {
          return filterKeys.every(function (eachKey) {
            if (!filters[eachKey].length) {
              return true
            }
            return filters[eachKey].includes(eachObj[eachKey])
          })
        })
      }
      let filteredItems = filtered(state.allItems, filters)
      if (state.kind === 'marketplace') {
        let now = new Date().getTime()
        console.log('filtering marketplace for embargoTime')
        filteredItems = filteredItems.filter(i => {
          console.log(`testing: ${i.embargoTime} < ${now}`)
          return i.embargoTime < now
        })
      }

      return filteredItems.reverse()
    }

  },
  // if you get any errors like:
  // [vuex] Do not mutate vuex store state outside mutation handlers.
  // read this again:
  // https://stackoverflow.com/questions/38365075/vuex-vuejs-do-not-mutate-vuex-store-state-outside-mutation-handlers

  mutations: {
    setInventoryPaginationPage: (state, payload) => {
      state.paginationPage = payload
    },
    setItemsPerPage: (state, payload) => {
      state.itemsPerPage = payload
    },
    setKind: (state, payload) => {
      state.kind = payload
    }
  },
  actions: {
    setPaginationPage: (context, page) => {
      context.commit('setInventoryPaginationPage', page)
    },
    unbindItems: firebaseAction(context => {
      if (context.state.allItems.length > 0) {
        context.unbindFirebaseRef('allItems')
      }
    }),
    manualSync: (context, id) => {
      let ref = db.ref(environment.schema.inventory).child(context.rootState.user.groupId).child(id)
      console.log('manualSync ref: ', ref.toString())
      return ref.update({ manualSync: true })
    },
    deleteItem: (context, payload) => {
      let ref = db.ref(environment.schema[payload.type]).child(context.rootState.user.groupId).child(payload.key)
      // console.log('delete ref: ', ref.toString())
      return ref.remove()
    },
    getItems: firebaseAction((context, payload) => {
      console.log('in vuex getItems...')
      context.commit('setKind', payload)
      let inventoryRef = db.ref(environment.schema[payload]).child(context.rootState.user.groupId)

      if (payload === 'marketplace') {
        console.log('inside the payload === marketplace')
        inventoryRef = db.ref(environment.schema[payload])
      }
      // if the user has any kind of filtering in place we need to use it.
      let selectedCollection = context.rootState.itemFilters.selectedCollection
      let selectedStyle = context.rootState.itemFilters.selectedStyle
      let selectedSize = context.rootState.itemFilters.selectedSize
      let selectedFabric = context.rootState.itemFilters.selectedFabric
      let selectedColorGroups = context.rootState.itemFilters.selectedColorGroups

      let searchByChild = false
      let searchByChildVal = ''
      // we need to set what the search child is
      // there has GOT to be a better way to do this!
      if (selectedCollection && selectedStyle && selectedSize && selectedFabric && selectedColorGroups) {
        searchByChild = 'collectionStyleSizeFabricColorGroups'
        searchByChildVal = `${selectedCollection}:${selectedStyle}:${selectedSize}:${selectedFabric}:${selectedColorGroups}`
      } else if (selectedCollection && selectedStyle && selectedSize && selectedFabric) {
        searchByChild = 'collectionStyleSizeFabric'
        searchByChildVal = `${selectedCollection}:${selectedStyle}:${selectedSize}:${selectedFabric}`
      } else if (selectedCollection && selectedStyle && selectedSize && selectedColorGroups) {
        searchByChild = 'collectionStyleSizeColorGroups'
        searchByChildVal = `${selectedCollection}:${selectedStyle}:${selectedSize}:${selectedColorGroups}`
      } else if (selectedCollection && selectedStyle && selectedSize) {
        searchByChild = 'collectionStyleSize'
        searchByChildVal = `${selectedCollection}:${selectedStyle}:${selectedSize}`
      } else if (selectedCollection && selectedStyle && selectedFabric && selectedColorGroups) {
        searchByChild = 'collectionStyleFabricColorGroups'
        searchByChildVal = `${selectedCollection}:${selectedStyle}:${selectedFabric}:${selectedColorGroups}`
      } else if (selectedCollection && selectedStyle && selectedFabric) {
        searchByChild = 'collectionStyleFabric'
        searchByChildVal = `${selectedCollection}:${selectedStyle}:${selectedFabric}`
      } else if (selectedCollection && selectedStyle && selectedColorGroups) {
        searchByChild = 'collectionStyleColorGroups'
        searchByChildVal = `${selectedCollection}:${selectedStyle}:${selectedColorGroups}`
      } else if (selectedCollection && selectedFabric && selectedColorGroups) {
        searchByChild = 'collectionFabricColorGroups'
        searchByChildVal = `${selectedCollection}:${selectedFabric}:${selectedColorGroups}`
      } else if (selectedCollection && selectedFabric) {
        searchByChild = 'collectionFabric'
        searchByChildVal = `${selectedCollection}:${selectedFabric}`
      } else if (selectedCollection && selectedColorGroups) {
        searchByChild = 'collectionColorGroups'
        searchByChildVal = `${selectedCollection}:${selectedColorGroups}`
      } else if (selectedCollection && selectedStyle) {
        searchByChild = 'collectionStyle'
        searchByChildVal = `${selectedCollection}:${selectedStyle}`
      } else if (selectedCollection) {
        searchByChild = 'collection'
        searchByChildVal = selectedCollection
      }

      if (searchByChild === 'collection') {
        inventoryRef = inventoryRef.orderByChild('collection').equalTo(searchByChildVal)
      } else if (searchByChild) {
        inventoryRef = inventoryRef.orderByChild(`searches/${searchByChild}`).equalTo(searchByChildVal)
      } else {
        // so we can limit and paginate with keys ... we need to limitToLast
        // since firebase puts newest on the bottom and oldest on top...yay!
        inventoryRef = inventoryRef.orderByKey()
      }
      console.log('inventory ref: ', inventoryRef.toString())
      context.bindFirebaseRef('allItems', inventoryRef)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/inventory.js